import type { PageLoad } from './$types';
import { error } from '@sveltejs/kit';

/** @type {import('./$types').PageLoad} */
export const load: PageLoad = ({ data }) => {
	if (data && Object.keys(data).length === 0 && Object.getPrototypeOf(data) === Object.prototype) {
		const errorMessage = `Sorry, this page not found.
		The link you followed probably broken or the page has been removed.
		`;
		throw error(404, errorMessage);
	}
	return data;
};
